import { Get } from "../api/ApiBase";

export async function GetSettings() {
    return await Get("/api/Settings");
  }